import { Redirect } from 'react-router-dom'

const RedirectCollaboratorsInit = () => {
  return <Redirect to="/dashboard/settings?tab=collaborators" />
}

export { RedirectCollaboratorsInit }
